import Model from './Model'

export default class Setting extends Model {
  resource () {
    return 'settings/general'
  }
}
